<template>
  <v-input
    :id="field.id"
    :error-messages="errors"
    :focused="focused"
    :hide-details="dense"
    :rules="rules"
    validate-on="input"
    :validation-value="modelValue"
  >
    <template #default="{ isValid }">
      <div
        class="v-field d-block"
        :class="{ 'v-field--error': isValid.value === false }"
      >
        <v-label v-if="!dense">
          <FieldLabel :field="field" />
        </v-label>

        <v-row dense>
          <v-col cols="6">
            <VTextField
              v-model="innerDate"
              :disabled="field.readonly"
              :error="!isValid"
              :hide-details="true"
              type="date"
              @update:focused="updateFocus('date', $event)"
            >
              <template
                v-if="dense"
                #label
              >
                <FieldLabel :field="field" />
              </template>
            </VTextField>
          </v-col>

          <v-col cols="6">
            <VTextField
              v-model="innerTime"
              :disabled="field.readonly"
              :error="!isValid"
              :hide-details="true"
              type="time"
              @update:focused="updateFocus('time', $event)"
            >
              <template
                v-if="dense"
                #label
              >
                <FieldLabel :field="field" />
              </template>
            </VTextField>
          </v-col>
        </v-row>
      </div>
    </template>
  </v-input>
</template>

<script setup lang="ts">
import { VTextField } from 'vuetify/components';

const props = defineProps<{
  field: FieldConfig
  rules?: FormRule[]
  errors?: string[]
  dense?: boolean
  modelValue: string | undefined
}>();
const emit = defineEmits(['update:modelValue']);

const innerDateFocused = ref(false);
const innerTimeFocused = ref(false);
const focused = computed(() => {
  return innerDateFocused.value || innerTimeFocused.value;
});

const innerDate = ref('');
const innerTime = ref('');
[innerDate.value, innerTime.value] = getDateTimeFromString(props.modelValue);

// Update the inner fields whenever the model changes
watch(() => props.modelValue, val => {
  [innerDate.value, innerTime.value] = getDateTimeFromString(val);
});

// Update the model whenever the inner fields change
watch([innerDate, innerTime], ([date, time]) => {
  emit('update:modelValue', `${date}T${time}`);
});

/**
 * Updates the `focused` ref for one of the two inner fields
 *
 * @param field
 * @param value
 */
const updateFocus = (field: 'date' | 'time', value: boolean) => {
  if (field === 'date') {
    innerDateFocused.value = value;
  }
  else {
    innerTimeFocused.value = value;
  }
};
</script>

<style scoped lang="scss">
.v-label {
  margin-inline-start: 8px;
}
</style>
